import { render, staticRenderFns } from "./AF.vue?vue&type=template&id=53ef90df&scoped=true&"
import script from "./AF.vue?vue&type=script&lang=js&"
export * from "./AF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ef90df",
  null
  
)

export default component.exports